<template>
  <v-card>
    <div class="pb-8">
      <PersonsTable />
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import store from '@/store'
import PersonsTable from '@/components/persons/PersonsTable'
import personsHelpers from '@/helpers/persons/personsHelpers'
import { persons } from '@/store/persons';

export default {
  components: {
    PersonsTable
  },
  data() {
    return {
      isAdmin: store.getters.isAdmin,
      tabs: [{ name: 'All' }]
    }
  },
  methods: {
    ...mapActions('persons', ['getPersonsList'])
  },
  computed: {
    ...mapGetters('persons', ['getPersons']),
    ...mapGetters('auth', ['session'])
  },
  watch: {
    async session(newSession) {
      //En caso que al inicio no hubiera una sesión abierta, observamos su estado
      //y cuando la misma este disponible obtenemos los datos
      //Escenario de uso: frente a un reload de página
      if (newSession.isOpen) {
        const userId = localStorage.getItem('user_id')
        const response = await personsHelpers.personFetch({userId})
        if (response.args[0].roles['mrn:party_role:user'].groups[0] === 'business_account_user') {
          this.$store.dispatch('persons/setPersons', response.args)
        } else {
          await this.getPersonsList()
        }
        this.$store.dispatch('things/getThingsList')
      }
    }
  },
  async created() {
    //Si la sesión de la conexión wamp se encuentra abierta obtengo los datos
    if (this.session.isOpen) {
      const userId = localStorage.getItem('user_id')
      const response = await personsHelpers.personFetch({userId})
      if (response.args[0].roles['mrn:party_role:user'].groups[0] === 'business_account_user') {
        this.$store.dispatch('persons/setPersons', response.args)
      } else {
        await this.getPersonsList()
      }
    }
  },
  beforeDestroy() {
    this.$store.dispatch('persons/resetPersonsState')
  }
}
</script>

<style scoped lang="scss"></style>
